import { Flex, PersonOutlinedIcon, Text } from '@shared/components';

export default function BlockedRecordsEmptyState() {
  return (
    <Flex
      sx={(theme) => ({
        backgroundColor: theme.palette.grey[50],
        border: '1px dashed',
        borderColor: theme.palette.grey[300],
        borderRadius: theme.shape.rounded(2),
        padding: theme.spacing(6, 0),
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(4),
      })}
    >
      <PersonOutlinedIcon
        sx={(theme) => ({
          fontSize: '48px',
          color: theme.palette.grey[400],
        })}
      />
      <Text variant='h4'>ยังไม่มีข้อมูลการถูกระงับสิทธิ์</Text>
    </Flex>
  );
}
